import { Controller } from "@hotwired/stimulus";
/**
 *
 * 概要:
 * 下限 (min) の選択値に応じて、対応する上限 (max) のセレクトボックスの選択肢を制御する。
 * 選択肢のペアごとに `data-range-filter-group` 属性を利用して識別することで、
 * 複数セットにも対応している。
 *
 * 主な用途:
 * - 例: 100万円以上 → 上限は100万円超からのみ選択可能
 *
 * 使用例:
 * <div data-controller="range-filter">
 *   <%= select_tag :price_min, ..., data: { range_filter_target: "min", range_filter_group: "price", action: "range-filter#filterMaxOptions" } %>
 *   <%= select_tag :price_max, ..., data: { range_filter_target: "max", range_filter_group: "price" } %>
 *
 *   <%= select_tag :model_min, ..., data: { range_filter_target: "min", range_filter_group: "model", action: "range-filter#filterMaxOptions" } %>
 *   <%= select_tag :model_max, ..., data: { range_filter_target: "max", range_filter_group: "model" } %>
 * </div>
 *
 */
export default class extends Controller {
  static targets = ["min", "max"];

  connect() {
    this.minTargets.forEach((min) => this.filterMaxOptions({ target: min }));
  }

  filterMaxOptions({ target }) {
    const group = target.dataset.rangeFilterGroup;
    const min = parseFloat(target.value);
    const max = this.maxTargets.find(
      (el) => el.dataset.rangeFilterGroup === group,
    );
    if (!max) return;

    const current = max.value;
    max._original ||= Array.from(max.options).map((o) => ({
      value: o.value,
      text: o.textContent,
    }));

    const filtered = max._original.filter((o) => {
      const v = parseFloat(o.value);
      return isNaN(min) || isNaN(v) || v > min;
    });

    max.options.length = 0;
    filtered.forEach((o) => max.add(new Option(o.text, o.value)));
    max.value = filtered.some((o) => o.value === current) ? current : "";
  }
}
